import Chats from "../../icons/Chats";
import Scales from "../../icons/Scales";
import { Product } from "../../../../../api/src/types";
import { PurchaseItemWithEventsGetResponse } from "../../../../../api/src/users/purchase-items/route";

export const getProductIcon = (
  product: Product | PurchaseItemWithEventsGetResponse[number]["product"],
) => {
  switch (product.productIcon) {
    case "Q_A":
      return <Chats />;
    case "REPRESENTATION":
      return <Scales />;
  }

  return null;
};

export const getPaymentPath = (
  isPrenupPaid: boolean,
  cartItemsLength: number,
) => {
  if (isPrenupPaid && cartItemsLength === 0) {
    return "/payment/history";
  }
  return "/payment";
};
